import { tokens } from '@fluentui/react-components';
import { makeStyles } from '@fluentui/react-components';

const buttonSelector = '& button[data-copy-field-value="true"]';

export const useStyles = makeStyles({
    row: {
        [buttonSelector]: {
            opacity: 0,
            transition: `opacity ${tokens.durationFast}`,
        },

        ':hover': {
            [buttonSelector]: {
                opacity: 1,
            },
        },
    },
    tableCellContent: {
        display: 'flex',
        alignItems: 'center',
        gap: tokens.spacingHorizontalXS,
    },
    tableCellAction: {
        textDecoration: 'underline',
        cursor: 'pointer',
    },
});
